import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

import InputField from "../../ui/form/InputField";
import FileInputField from "../../ui/form/FileInputField";
import Button from "../../ui/Button";

/* ================= VALIDATION (CLIENT SIDE) ================= */
const MemberValidation = Yup.object({
  name: Yup.string().required("Name is required"),
  father_name: Yup.string().required("Father name required"),
  contact_no: Yup.string()
    .matches(/^[0-9]{10}$/, "Invalid mobile")
    .required("Mobile required"),
  email: Yup.string().email("Invalid email").required("Email required"),
  department: Yup.string().required("Department required"),
});

/* ================= COMPONENT ================= */
const MembershipApplication = () => {
  const [serverErrors, setServerErrors] = useState({});

  const formik = useFormik({
    initialValues: {
      name: "",
      father_name: "",
      contact_no: "",
      contact_no_two: "",
      email: "",
      blood_group: "",
      dob: "",
     
      department: "",
      address: "",
      state: "",
      district: "",
      city: "",
      village: "",
      education_qualification: "",
      technical_qualification: "",
      resi: "",
      native_place_address: "",
      native_village: "",
      native_taluka: "",
      native_district: "",
      native_mobile: "",
   
      photo: null,
    },

    validationSchema: MemberValidation,

    onSubmit: async (values, { resetForm }) => {
      setServerErrors({});

      try {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
          if (values[key]) formData.append(key, values[key]);
        });

        await axios.post(
          `${process.env.REACT_APP_API_URL}members`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("useAccessToken")}`,
            },
          }
        );

        alert("✅ Member Created Successfully");
        resetForm();
      } catch (error) {
        if (error.response?.status === 422) {
          setServerErrors(error.response.data.errors || {});
        } else {
          alert("❌ Something went wrong");
        }
      }
    },
  });

  const f = formik;

  /* ================= HELPER ================= */
  const fieldError = (name) =>
    (f.touched[name] && f.errors[name]) || serverErrors[name]?.[0];

  return (
    <div className="max-w-7xl mx-auto p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <div className="bg-indigo-700 text-white p-6 text-center text-3xl font-bold">
          Membership Application
        </div>

        <form onSubmit={f.handleSubmit} className="p-8 space-y-10">

{/* ================= PERSONAL ================= */}
<section>
<h2 className="font-bold text-xl mb-4">Personal Details</h2>
<div className="grid md:grid-cols-2 gap-6">

<InputField id="name" label="Full Name"
  value={f.values.name}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("name")}
/>

<InputField id="father_name" label="Father Name"
  value={f.values.father_name}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("father_name")}
/>

<InputField id="contact_no" label="Mobile"
  value={f.values.contact_no}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("contact_no")}
/>

<InputField id="contact_no_two" label="Alternate Mobile"
  value={f.values.contact_no_two}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="email" label="Email"
  value={f.values.email}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("email")}
/>

<InputField id="blood_group" label="Blood Group"
  value={f.values.blood_group}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="dob" type="date" label="DOB"
  value={f.values.dob}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("dob")}
/>

</div>
</section>

{/* ================= PROFESSIONAL ================= */}
<section>
<h2 className="font-bold text-xl mb-4">Professional Details</h2>
<div className="grid md:grid-cols-2 gap-6">

<InputField id="department" label="Department"
  value={f.values.department}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("department")}
/>

<InputField id="education_qualification" label="Education Qualification"
  value={f.values.education_qualification}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="technical_qualification" label="Technical Qualification"
  value={f.values.technical_qualification}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>


</div>
</section>

{/* ================= ADDRESS ================= */}
<section>
<h2 className="font-bold text-xl mb-4">Current Address</h2>
<div className="grid md:grid-cols-2 gap-6">

<InputField id="address" label="Address"
  value={f.values.address}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("address")}
/>

<InputField id="state" label="State"
  value={f.values.state}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="district" label="District"
  value={f.values.district}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="city" label="City"
  value={f.values.city}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="village" label="Village"
  value={f.values.village}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="resi" label="Residence Type"
  value={f.values.resi}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

</div>
</section>

{/* ================= NATIVE ================= */}
<section>
<h2 className="font-bold text-xl mb-4">Native Details</h2>
<div className="grid md:grid-cols-2 gap-6">

<InputField id="native_place_address" label="Native Address"
  value={f.values.native_place_address}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="native_village" label="Native Village"
  value={f.values.native_village}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="native_taluka" label="Native Taluka"
  value={f.values.native_taluka}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="native_district" label="Native District"
  value={f.values.native_district}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
/>

<InputField id="native_mobile" label="Native Mobile"
  value={f.values.native_mobile}
  onChange={f.handleChange}
  onBlur={f.handleBlur}
  error={fieldError("native_mobile")}
/>

</div>
</section>


{/* ================= PHOTO ================= */}
<section>
<h2 className="font-bold text-xl mb-4">Profile Photo</h2>
<FileInputField
  id="photo"
  onChange={(e) => f.setFieldValue("photo", e.currentTarget.files[0])}
  error={serverErrors.photo?.[0]}
/>
</section>

<div className="flex justify-end">
<Button type="submit" variant="primary">
Submit
</Button>
</div>

        </form>
      </div>
    </div>
  );
};

export default MembershipApplication;
